<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Popup',
});
</script>
<template>
  <!-- Dialog 弹窗模式 -->
  <el-dialog
    v-if="type === 'dialog'"
    v-model="visible"
    :title="title"
    :close-on-click-modal="false"
    :width="width"
    :show-close="showClose"
    @close="handleClose"
  >
    <div class="dia-contain" :style="{ padding: type === 'dialog' ? '20px 24px' : '20px 0px' }">
      <slot />
      <div v-for="expandItem in expandData" :key="expandItem.title" class="dia-contain-list">
        <div class="contain-item-title">
          <div class="contain-item-title-before" />
          {{ $t(expandItem.title) }}
        </div>
        <div
          v-for="item in expandItem.exList"
          v-show="checkShowByCode(dataObj, item)"
          :key="item.label"
          class="dia-contain-item"
        >
          <div v-if="labelConfig[item.label]" class="item-label item-label-with-tooltip">
            {{ $t(item.label) }}:
            <el-tooltip
              class="box-item"
              popper-class="tooltip-expand"
              effect="dark"
              raw-content
              :content="getTooltipContent(item)"
              placement="top"
            >
              <img class="tooltip-icon" :src="tip5" alt="" />
            </el-tooltip>
          </div>
          <div v-else class="item-label">{{ $t(item.label) }}:</div>

          <div class="item-value">
            <slot :name="item.value" :item="item" :data="dataObj">
              <span>{{ formatValue(item, dataObj) }}</span>
            </slot>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer dialog-footer-view">
        <slot name="footer" :close="handleClose">
          <el-button type="primary" class="btn" plain @click="handleClose">
            {{ $t(closeText) }}
          </el-button>
        </slot>
      </div>
    </template>
  </el-dialog>

  <!-- Drawer 抽屉模式 -->
  <el-drawer
    v-else-if="type === 'drawer'"
    v-model="visible"
    :title="title"
    :size="drawerSize"
    :direction="direction"
    @close="handleClose"
  >
    <div class="dia-contain">
      <slot />
      <div v-for="expandItem in expandData" :key="expandItem.title" class="dia-contain-list">
        <div class="contain-item-title">
          <div class="contain-item-title-before" />
          {{ $t(expandItem.title) }}
        </div>
        <div
          v-for="item in expandItem.exList"
          v-show="checkShowByCode(dataObj, item)"
          :key="item.label"
          class="dia-contain-item"
        >
          <div v-if="labelConfig[item.label]" class="item-label item-label-with-tooltip">
            {{ $t(item.label) }}:
            <el-tooltip
              class="box-item"
              popper-class="tooltip-expand"
              effect="dark"
              raw-content
              :content="getTooltipContent(item)"
              placement="top"
            >
              <img class="tooltip-icon" :src="tip5" alt="" />
            </el-tooltip>
          </div>
          <div v-else class="item-label">{{ $t(item.label) }}:</div>

          <div class="item-value">
            <slot :name="item.value" :item="item" :data="dataObj">
              <span>{{ formatValue(item, dataObj) }}</span>
            </slot>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer" style="display: flex; justify-content: center">
        <slot name="footer" :close="handleClose">
          <el-button type="primary" class="btn" plain @click="handleClose">
            {{ $t(closeText) }}
          </el-button>
        </slot>
      </div>
    </template>
  </el-drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@klondpay/locales';
import { tip5 } from '@klondpay/assets';

const { t } = useI18n();

export interface PopupItem {
  label: string;
  value: string;
  [key: string]: any;
}

export interface ExpandItem {
  title: string;
  exList: PopupItem[];
}

export interface PopupProps {
  // 基础配置
  modelValue: boolean;
  type?: 'dialog' | 'drawer';
  title?: string;

  // Dialog 配置
  width?: string;
  showClose?: boolean;

  // Drawer 配置
  drawerSize?: string | number;
  direction?: 'rtl' | 'ltr' | 'ttb' | 'btt';

  // 数据配置
  expandData?: ExpandItem[];
  dataObj?: Record<string, any>;
  labelConfig?: Record<string, any>;

  // 文本配置
  closeText?: string;

  // 业务配置
  activeAbil?: string;
  discountTableIsRefund?: boolean;
  valueList?: string[]; // 特殊值字段列表
}

const props = withDefaults(defineProps<PopupProps>(), {
  type: 'dialog',
  title: '详情',
  width: '62%',
  showClose: false,
  drawerSize: '50%',
  direction: 'rtl',
  expandData: () => [],
  dataObj: () => ({}),
  labelConfig: () => ({}),
  closeText: '关闭',
  activeAbil: '',
  discountTableIsRefund: false,
  valueList: () => [
    'vplanRef',
    'externalTransactionRef',
    'vplanID',
    'vplanAcceptanceId',
    'numberOfInstallments',
    'installmentFrequency',
    'totalPlanCost',
    'totalFees',
    'Famount',
    'FinstallmentFee',
    'FupfrontFee',
    'Lamount',
    'LinstallmentFee',
    'LupfrontFee',
  ],
});

console.log('props.expandData', props.expandData);
console.log('props.dataObj', props.dataObj);

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  close: [];
}>();

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

// 检查是否显示某个字段
const checkShowByCode = (dataObj: Record<string, any>, item: PopupItem) => {
  // 原商户交易单号：所有业务类型均展示（与交易详情需求一致）
  if (item.value === 'oriSysId') {
    return true;
  }

  let back = false;

  if (checkHasValue(item.value)) {
    if (dataObj.transCode === 'VI10' || dataObj.transCode === 'VI11') {
      back = true;
    }
  } else {
    back = true;
  }

  // 八达通展示判断
  if (item.label === 'SP ID' || item.label === 'SP Group ID') {
    if (dataObj?.productType !== 'BD') {
      back = false;
    }
  }

  return back;
};

// 获取提示内容
const getTooltipContent = (item: PopupItem) => {
  const config = props.labelConfig[item.label];
  if (!config) return '';

  // 特殊处理币种和汇率的提示
  if (item.label === '币种' || item.label === '汇率') {
    if (props.discountTableIsRefund) {
      return item.label === '币种'
        ? t('原商品标价币种。')
        : t('rateTip4') +
            '<br>' +
            t('rateTip5') +
            '<br>' +
            t('rateTip6') +
            '<br>' +
            t('rateTip7') +
            '<br>' +
            t('rateTip8');
    } else {
      return item.label === '币种'
        ? t('商品标价币种。')
        : t('rateTip1') + '<br>' + t('rateTip9') + '<br>' + t('rateTip2') + '<br>' + t('rateTip3');
    }
  }

  return config.comment ? t(config.comment) || '' : '';
};

// 格式化显示值
const formatValue = (item: PopupItem, dataObj: Record<string, any>) => {
  const value = dataObj[item.value];

  // 分期特殊展示 - 如果是特殊值字段且为分期交易
  if (checkHasValue(item.value) && (dataObj.transCode === 'VI10' || dataObj.transCode === 'VI11')) {
    return value ? value : '/';
  }

  // 特殊字段处理
  switch (item.value) {
    case 'transType':
      return value === '0' ? t('标志一') : t('标志二');

    case 'orderStatus':
      if (value === '0') return t('正常');
      if (value === '1') return t('已冲正');
      if (value === '2') return t('已撤销');
      if (value === '3') {
        return props.activeAbil === 'VISA分期' ? t('VISA已退款') : t('已退款');
      }
      if (value === '4') return t('失败');
      if (value === '5') {
        return props.activeAbil === 'VISA分期' ? t('VISA部分退款') : t('部分退款');
      }
      if (value === '6') return t('支付中');
      if (value === '7') return t('拒绝');
      return value || '/';

    case 'transCode':
      return value === 'VI10' || value === 'VI11' ? t('标志一') : t('标志二');

    case 'testfont1':
      return dataObj.isHaveDiscount === '1' ? t('有') : t('无');

    case 'testfont2': {
      const amount = dataObj.actualPaymentAmount ? dataObj.actualPaymentAmount : '/';
      const currency = dataObj.actualPaymentCurrency ? `(${dataObj.actualPaymentCurrency})` : '';
      return `${amount} ${currency}`;
    }

    default:
      return value || '/';
  }
};

// 检查是否为特殊值字段
const checkHasValue = (val: string) => {
  return props.valueList.includes(val);
};

// 关闭处理
const handleClose = () => {
  visible.value = false;
  emit('close');
};

// 定义组件名称
;
</script>

<style scoped lang="scss">
/* -----------------流水和日志弹窗------------------- */
.dia-contain {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  width: 100%;
  // padding: 20px 0px;

  .dia-contain-item {
    width: 31%;
    min-height: 34px;
    margin-right: 1.5%;
    margin-bottom: 20px;
    word-break: keep-all;

    .item-label {
      font-size: 12px;
      font-weight: 700;
      color: #87909c;
    }

    .item-value {
      font-size: 14px;
      font-weight: 400;
      color: #333;

      span {
        word-break: keep-all !important;
        overflow-wrap: break-word;
        white-space: normal;
      }
    }
  }
}

.tooltip-icon {
  width: 15px;
  height: 15px;
  margin-left: 4px;
  cursor: pointer;
}

.item-label-with-tooltip {
  display: flex;
  align-items: center;
}

.item-label-with-tooltip {
  display: flex;
  align-items: center;
}

.dialog-footer-view {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -10px;
  line-height: 22px;
}

.dia-contain-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .contain-item-title {
    display: flex;
    align-items: center;
    // color: #134aa4;
    // color: #039FFF;
    width: 100%;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #1d2130;

    .contain-item-title-before {
      width: 5px;
      height: 14px;
      margin-right: 5px;
      background-color: #039fff;
    }
  }
}

/* -----------------流水和日志弹窗------------------- */
// 抽屉模式下的样式调整
:deep(.el-drawer__body) {
  // padding: 20px;
}
</style>
